var _Rect, _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";

function SvgCoros(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 335,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 1,
    y: 1,
    width: 333,
    height: 58,
    rx: 5.598,
    stroke: "#B8B8B8",
    strokeWidth: 2
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#coros_svg__clip0_4078_11595)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M116.16 25.4l1.429-.868.924 8.187.094.315 7.608 4.392c.127.04.507-.15.662-.21 2.422-.95 4.764-2.117 7.199-3.036v1.582l-8.754 5.001-9.162-5.256V25.4z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M128.768 16.722l8.677 5.029c.046.055.094.58.102.714.02.33-.013.665 0 .995l-7.86-3.393-7.684 4.464-1.045 8.423-1.277-.74-.05-.102.009-10.125 9.077-5.265h.051zM220.955 26.625v1.531h-11.588v1.327h10.388c.031 0 .359.16.418.195.444.26.627.66.782 1.133-.053.577.071 1.276 0 1.837-.05.39-.347.867-.667 1.095-.067.047-.54.283-.584.283h-12.736v-1.53h11.639V31.04l-.077-.076h-10.362c-.339 0-.937-.609-1.072-.92-.2-.457-.194-1.988.001-2.449.269-.636.914-.95 1.579-.973l12.279.003z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M138.711 37.13l-8.667 4.99h-.206l-1.325-.693.032-.105 6.796-5.01-.014-8.921-6.763-5.155 1.381-.743 8.751 5.08.015 10.557zM185.938 31.627l3.522 2.4h-3.037l-3.573-2.4h-4.364v-1.531h8.575v-1.94h-9.239v5.87h-2.348v-6.15c0-.573 1.028-1.338 1.608-1.25 3.481.163 7.163-.22 10.62-.004.759.048 1.515.41 1.685 1.225.089.429.065 1.9.024 2.378-.048.562-.655 1.402-1.253 1.402h-2.22zM192.716 26.64l10.808-.017c.881.066 1.501.51 1.656 1.406-.101 1.48.137 3.14.003 4.596a1.588 1.588 0 01-1.355 1.401l-11.232.003c-.729-.067-1.299-.706-1.396-1.412.089-1.442-.137-3.064-.004-4.485.078-.834.692-1.422 1.52-1.492zm10.117 1.567h-9.29v4.237h9.29v-4.237zM161.222 26.64l10.808-.017c.915.043 1.574.64 1.656 1.56.1 1.111.091 3.17.003 4.289-.064.803-.565 1.393-1.354 1.555l-11.232.002c-.676-.047-1.316-.634-1.396-1.31-.175-1.466.119-3.242-.006-4.741.144-.746.751-1.312 1.521-1.338zm10.117 1.517h-9.29v4.287h9.29v-4.288zM157.914 26.625v1.531H146.48v4.34h11.434v1.53h-12.735c-.02 0-.319-.12-.367-.143-.505-.253-.841-.803-.886-1.36-.091-1.152-.098-3.248 0-4.394.063-.736.735-1.503 1.508-1.503h12.48z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "coros_svg__clip0_4078_11595"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(116.16 16.722)",
    d: "M0 0h104.817v25.399H0z"
  })))));
}

export default SvgCoros;